
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 60 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.818 11.45A9 9 0 1039 20a9 9 0 00-.412-2.7","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M34.5 20a4.5 4.5 0 11-4.5-4.5","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M36.75 13.25L30 20m6.75-6.75V11m0 2.25H39","stroke":"currentColor","stroke-width":"1.8","stroke-linecap":"round"}})])
          )
        }
      }
    